import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { Router, matchPath, useParams } from "react-router-dom"
import { createBrowserHistory } from "history"
import * as Sentry from "@sentry/react"
import { replayIntegration } from "@sentry/replay"

import "./i18n"
import { Provider } from "react-redux"

import store from "./store"
import reportWebVitals from "./reportWebVitals"
import { authProtectedRoutes, publicRoutes } from "./routes"

const allRoutes = [...authProtectedRoutes, ...publicRoutes]

export const appHistory = createBrowserHistory()

Sentry.init({
  dsn: "https://df874d08971348b2b0e6d5cb95daf678@o1032553.ingest.us.sentry.io/5999510",
  integrations: [
    Sentry.reactRouterV5BrowserTracingIntegration({
      history: appHistory,
      routes: allRoutes,
      matchPath,
      useParams,
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: process.env.REACT_APP_ENV,
  normalizeDepth: 5,
  maxBreadcrumbs: 50,
  beforeSend(event) {
    if (!event.user || (!event.user.id && !event.user.email)) {
      const token = localStorage.getItem("authUser")
      const fingerprint =
        token && token.length > 0 ? hashToken(token) : "anonymous"
      event.user = {
        id: fingerprint,
        type: fingerprint === "anonymous" ? "anonymous" : "jwt-fingerprint",
      }
    }
    if (event.exception && event.exception.values) {
      event.tags = {
        ...event.tags,
        handled: false,
        source: "error-boundary",
      }
    }
    return event
  },
})

function hashToken(token) {
  let hash = 0
  for (let i = 0; i < token.length; i++) {
    hash = ((hash << 5) - hash + token.charCodeAt(i)) | 0
  }
  return `u_${Math.abs(hash).toString(36)}`
}

const app = (
  <Provider store={store}>
    <Router history={appHistory}>
      <App />
    </Router>
  </Provider>
)

ReactDOM.render(app, document.getElementById("root"))
serviceWorker.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
